import NotificationEmitter from '../../src/components/NotificationEmitter.vue';

export default {
  components: {
    NotificationEmitter,
  },
};
